import type { AgentParams } from '../../../../services/authService';
import { formatDateTimeMMDDYYYY, formatUtcAssumedDateTimeMMDDYYYY, parseUtcAssumedDate } from '../../../../utils/formatUtils';

export const ACTIVITY_FEED_PAGE_SIZE_OPTIONS = [100, 200, 500];
export const DEFAULT_ACTIVITY_FEED_PAGE_SIZE = 100;
export const AGENT_CONFIGURATION_AVAILABLE_EXTENSIONS = ['pdf', 'xml', 'txt', 'json', 'log'];

export const getInitials = (name: string): string => {
    if (name === 'System') return 'SY';
    const parts = name.split(' ');
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};

export const getAvatarColor = (name: string): string => {
    if (name === 'System') return '#2C6CA0';
    if (name === 'Dianne Russell') return '#FF6B35';
    return '#2C6CA0';
};

export const formatLastSync = (createdAt?: string | null, updatedAt?: string | null): string | null => {
    const candidates = [updatedAt, createdAt].filter(Boolean) as string[];
    if (candidates.length === 0) return null;

    const latest = candidates
        .map((value) => parseUtcAssumedDate(value))
        .filter((date): date is Date => date !== null)
        .filter((date) => !Number.isNaN(date.getTime()))
        .sort((left, right) => right.getTime() - left.getTime())[0];

    if (!latest) return null;

    return formatDateTimeMMDDYYYY(latest);
};

export const formatSeenTimestamp = (value?: string | null): string | null => {
    if (!value) return null;
    return formatUtcAssumedDateTimeMMDDYYYY(value);
};

export const getDeviceIdFromAgentParams = (params: AgentParams | null | undefined): string | null => {
    if (!params || typeof params !== 'object') return null;
    const resolved = params.device_id ?? null;
    if (typeof resolved !== 'string') return null;
    const trimmed = resolved.trim();
    return trimmed.length > 0 ? trimmed : null;
};
